import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import fr from 'vuetify/lib/locale/fr'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { fr },
    current: 'fr',
  },
  icons: {
    iconfont: 'md',
  },
  theme: {
    options: { customProperties: true },
    dark: true,
    themes: {
      light: {
        primary: '#27569e',
        secondary: '#576A74',
        accent: '#8A3E70',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
        lightbg: '#FFF',
      },
      dark: {
        primary: '#27569e',
        secondary: '#121212',
        accent: '#8A3E70',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
        lightbg: '#27569e',
      },
    },
  },
})
